var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPitchedRoofMajcoat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 122.15 117.59",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.14,
    y: 0.14,
    width: 132.01,
    height: 117.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    x: 37.55,
    y: 34.99,
    width: 79.74,
    height: 79.15,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.62,34.99L37.55,110.82l2.64,2.63L116.26,37.62l-2.64-2.63Z",
    fill: "#fff"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.62,34.99L37.55,110.82l2.64,2.63L116.26,37.62l-2.64-2.63Z",
    fill: "#234c6f",
    isolation: "isolate",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75,87.88l-2.6,2.6.85.85,2.6-2.6-.85-.84Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.99,91.47l-1-1,2.75-2.75,1,1-2.75,2.75ZM17.3,90.47l.7.69,2.45-2.45-.7-.69-2.45,2.44Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.96,82.68l-2.6,2.6.85.84,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,86.28l-1-1,2.76-2.75,1,1-2.75,2.75ZM22.5,85.28l.7.69,2.45-2.44-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.16,77.49l-2.6,2.6.85.84,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.41,81.08l-1-1,2.75-2.75,1,1-2.75,2.75ZM27.71,80.09l.7.69,2.45-2.44-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.37,72.3l-2.6,2.6.85.85,2.6-2.6-.85-.84Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.62,75.89l-1-1,2.75-2.75,1,1-2.75,2.75ZM32.92,74.9l.7.69,2.45-2.45-.7-.69-2.45,2.44Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,67.11l-2.6,2.6.85.85,2.6-2.6-.85-.84Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.83,70.7l-1-1,2.75-2.75,1,1-2.75,2.75ZM38.13,69.7l.7.69,2.45-2.45-.7-.69-2.45,2.44Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.79,61.92l-2.6,2.6.85.84,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.04,65.51l-1-1,2.75-2.75,1,1-2.75,2.75ZM43.34,64.51l.7.69,2.45-2.44-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,56.72l-2.6,2.6.85.84,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.24,60.31l-1-1,2.75-2.75,1,1-2.75,2.75ZM48.55,59.32l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,51.53l-2.6,2.6.85.84,2.6-2.6-.85-.84Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.45,55.12l-1-1,2.76-2.75,1,1-2.75,2.75ZM53.75,54.13l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.42,46.34l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.66,49.93l-1-1,2.75-2.75,1,1-2.75,2.75ZM58.96,48.94l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.63,41.15l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.87,44.74l-1-1,2.76-2.75,1,1-2.76,2.75ZM64.17,43.74l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.83,35.95l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.08,39.55l-1-1,2.75-2.75,1,1-2.75,2.75ZM69.38,38.55l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.04,30.76l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,34.35l-1-1,2.76-2.75,1,1-2.76,2.75ZM74.59,33.36l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,25.57l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.49,29.16l-1-1,2.76-2.75,1,1-2.76,2.75ZM79.8,28.17l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.46,20.38l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7,23.97l-1-1,2.76-2.75,1,1-2.75,2.75ZM85.01,22.97l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.67,15.19l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.91,18.78l-1-1,2.76-2.75,1,1-2.76,2.75ZM90.22,17.78l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,91.51c-.08,0-.16-.03-.23-.09l-.8-.8c-.06-.06-.09-.14-.09-.23s.03-.17.09-.23L92.98,14.41c.12-.12.33-.12.45,0l.8.8c.06.06.09.14.09.23s-.03.17-.09.23L18.23,91.42c-.06.06-.14.09-.23.09ZM17.66,90.4l.35.34L93.55,15.43l-.35-.34L17.66,90.4Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.19,113.77c-.08,0-.16-.03-.23-.09l-2.64-2.63c-.06-.06-.09-.14-.09-.23s.03-.17.09-.23L113.4,34.77c.12-.12.33-.12.45,0l2.64,2.63c.06.06.09.14.09.23s-.03.17-.09.23L40.42,113.67c-.06.06-.14.09-.23.09ZM38.01,110.82l2.18,2.18L115.8,37.62l-2.18-2.18L38.01,110.82Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.54,111.06c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.16,111.06s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.15,112.35s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.11,109.95c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0s.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.76,108.81c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.64,108.39c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,106.04h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,107.65s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.88,106.77s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.56,104.06c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.18,104.06s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.17,105.35s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15s.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.13,102.95c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.78,101.81c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.66,101.4c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.37,99.04h-.58c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.58c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.79,100.66s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9,99.77s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26s.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.58,97.06c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2,97.06s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.19,98.35s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.15,95.95c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8,94.81c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.68,94.4c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.39,92.05h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,93.66s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.92,92.77s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6,90.06c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.22,90.06s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22s.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.21,91.36s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.17,88.96c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.82,87.81c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,87.4c-.07,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.41,85.05h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.83,86.66s0,0,0,0c-.12,0-.21-.11-.2-.22l.03-.56c0-.12.11-.21.22-.2.12,0,.21.11.2.22l-.03.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.94,85.78s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.69,82.99c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.31,82.99s0,0,0,0l-.56-.03c-.12,0-.21-.11-.2-.22,0-.12.11-.21.22-.2l.56.03c.12,0,.21.11.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3,84.29s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.26,81.89c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.91,80.75c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.79,80.33c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,77.98h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.92,79.59s0,0-.01,0c-.12,0-.21-.11-.2-.22l.03-.56c0-.12.1-.2.22-.2.12,0,.21.11.2.22l-.03.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.03,78.71s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.71,76c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.33,76s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22s.1-.2.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,77.29s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.28,74.89c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,73.75c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.81,73.34c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,70.98h-.58c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.58c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.94,72.6s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.05,71.71s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.73,69c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,69s0,0,0,0l-.56-.03c-.12,0-.21-.11-.2-.22s.11-.21.22-.2l.56.03c.12,0,.21.11.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,70.29s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,67.89c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.95,66.75c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.83,66.34c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.54,63.98h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.96,65.6s0,0,0,0c-.12,0-.21-.11-.2-.22l.03-.56c0-.12.11-.2.22-.2.12,0,.21.11.2.22l-.03.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.07,64.71s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.75,62c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.37,62s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.1-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.36,63.3s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.32,60.9c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.97,59.75c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,59.34c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.56,56.99h-.58c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.58c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.98,58.6s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.09,57.72s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,55.01c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.38,55.01s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.2.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,56.31s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.33,53.91c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.98,52.77c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.86,52.35c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.57,50h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.99,51.61s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1,50.73s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,48.01c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4,48.01s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22s.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.39,49.31s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.35,46.91c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,45.77c-.06,0-.11-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3s.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,45.36c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,43h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.01,44.62s0,0,0,0c-.12,0-.21-.11-.2-.22l.03-.56c0-.12.11-.2.22-.2.12,0,.21.11.2.22l-.03.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12,43.73s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8,41.02c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.42,41.02s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22s.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.41,42.31s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.37,39.91c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.02,38.77c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,38.36c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.03,37.62s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.2.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.14,36.73s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.73,114.15c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61,113.73c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.32,111.38h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.74,112.99s0,0-.01,0c-.12,0-.21-.11-.2-.22l.03-.56c0-.12.1-.21.22-.2.12,0,.21.11.2.22l-.03.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.85,112.11s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.53,109.4c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.15,109.4s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.14,110.69s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,108.29c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0s.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.75,107.15c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.63,106.74c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.34,104.38h-.58c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.58c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.76,106s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.87,105.11s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26s.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.55,102.4c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.17,102.4s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.16,103.69s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,101.29c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,100.15c-.06,0-.11-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65,99.74c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36,97.38h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.78,99s0,0,0,0c-.12,0-.21-.11-.2-.22l.03-.56c0-.12.11-.21.22-.2.12,0,.21.11.2.22l-.03.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.89,98.11s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.57,95.4c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,95.4s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.18,96.7s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14,94.3c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.79,93.15c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.67,92.74c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38,90.39h-.58c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.58c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,92s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.91,91.11s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.66,88.33c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.28,88.33s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22s.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.27,89.63s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.23,87.23c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.88,86.09c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,85.67c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.47,83.32h-.58c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.58c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.89,84.93s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,84.05s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26s.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.68,81.34c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3,81.34s0,0,0,0l-.56-.03c-.12,0-.21-.11-.2-.22,0-.12.11-.2.22-.2l.56.03c.12,0,.21.11.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.29,82.63s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.25,80.23c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9,79.09c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.78,78.68c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.49,76.32h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.91,77.94s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.2.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.02,77.05s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,74.34c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.32,74.34s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22s.1-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31,75.63s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.27,73.23c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.92,72.09c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8,71.68c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.51,69.32h-.58c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.58c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.93,70.94s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.04,70.05s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.72,67.34c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,67.34s0,0,0,0l-.56-.03c-.12,0-.21-.11-.2-.22s.11-.21.22-.2l.56.03c.12,0,.21.11.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.33,68.64s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,66.24c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.94,65.09c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.82,64.68c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.53,62.33h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.95,63.94s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.2.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.06,63.05s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.73,60.35c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.35,60.35s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.34,61.65s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3,59.25c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.95,58.1c-.06,0-.11-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,57.69c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.54,55.34h-.59c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.59c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.96,56.95s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.07,56.07s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.75,53.35c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.37,53.35s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22,0-.12.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.36,54.65s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32,52.25c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.97,51.11c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85,50.69c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56,48.34h-.58c-.12,0-.21-.1-.21-.21s.1-.21.21-.21h.58c.12,0,.21.1.21.21s-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.98,49.95s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.09,49.07s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.77,46.36c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,46.36s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22s.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.38,47.65s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34,45.25c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0s.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.99,44.11c-.06,0-.11-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.87,43.7c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,42.96s0,0,0,0c-.12,0-.21-.1-.2-.22l.02-.56c0-.12.11-.21.22-.2.12,0,.21.1.2.22l-.02.56c0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,42.07s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26s.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.74,40.4c-.12,0-.21-.1-.21-.21v-.58c0-.12.1-.21.21-.21s.21.1.21.21v.58c0,.12-.1.21-.21.21Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36,40.4s0,0,0,0l-.56-.02c-.12,0-.21-.1-.2-.22s.11-.21.22-.2l.56.02c.12,0,.21.1.2.22,0,.11-.1.2-.21.2Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.36,41.7s-.04,0-.06,0c-.11-.03-.18-.15-.15-.26l.12-.41c.03-.11.15-.18.26-.15.11.03.18.15.15.26l-.12.41c-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.31,39.3c-.05,0-.11-.02-.15-.06-.08-.08-.08-.22,0-.3l.41-.41c.08-.08.22-.08.3,0,.08.08.08.22,0,.3l-.41.41s-.1.06-.15.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.96,38.16c-.06,0-.12-.02-.16-.07l-.38-.41c-.08-.09-.07-.22.01-.3.09-.08.22-.07.3.01l.38.41c.08.09.07.22-.01.3-.04.04-.09.06-.14.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.84,37.74c-.08,0-.15-.04-.19-.11-.06-.1-.02-.23.08-.29l.37-.21c.1-.06.23-.02.29.08.06.1.02.23-.08.29l-.37.21s-.07.03-.1.03Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.08,36.12s-.04,0-.06,0l-.41-.12c-.11-.03-.18-.15-.15-.26.03-.11.15-.18.26-.15l.41.12c.11.03.18.15.15.26-.03.09-.11.15-.2.15Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.06,97.69c-.08,0-.16-.03-.23-.09-.12-.12-.12-.33,0-.45l35.28-35.17c.13-.12.33-.12.45,0,.12.13.12.33,0,.45l-35.28,35.17c-.06.06-.14.09-.23.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38,79.54l-2.6,2.6.85.85,2.6-2.6-.85-.84Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63,83.13l-1-1,2.75-2.75,1,1-2.75,2.75ZM8.93,82.14l.7.69,2.45-2.45-.7-.69-2.45,2.44Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.59,74.35l-2.6,2.6.85.85,2.6-2.6-.85-.84Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.84,77.94l-1-1,2.75-2.75,1,1-2.75,2.75ZM14.14,76.94l.7.69,2.45-2.45-.7-.69-2.45,2.44Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,69.16l-2.6,2.6.85.84,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.04,72.75l-1-1,2.75-2.75,1,1-2.75,2.75ZM19.35,71.75l.7.69,2.45-2.44-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.01,63.96l-2.6,2.6.85.84,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.25,67.55l-1-1,2.75-2.75,1,1-2.75,2.75ZM24.56,66.56l.7.69,2.45-2.44-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,58.77l-2.6,2.6.85.84,2.6-2.6-.85-.84Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.46,62.36l-1-1,2.75-2.75,1,1-2.75,2.75ZM29.77,61.37l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.43,53.58l-2.6,2.6.85.85,2.6-2.6-.85-.84Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.67,57.17l-1-1,2.75-2.75,1,1-2.76,2.75ZM34.97,56.17l.7.69,2.45-2.45-.7-.69-2.45,2.44Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.64,48.39l-2.6,2.6.85.84,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.88,51.98l-1-1,2.75-2.75,1,1-2.75,2.75ZM40.18,50.98l.7.69,2.45-2.44-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.84,43.19l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.09,46.78l-1-1,2.75-2.75,1,1-2.76,2.75ZM45.39,45.79l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.05,38l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3,41.59l-1-1,2.75-2.75,1,1-2.76,2.75ZM50.6,40.6l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.26,32.81l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,36.4l-1-1,2.76-2.75,1,1-2.76,2.75ZM55.81,35.41l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.47,27.62l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.71,31.21l-1-1,2.75-2.75,1,1-2.75,2.75ZM61.02,30.21l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,22.43l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.92,26.02l-1-1,2.75-2.75,1,1-2.76,2.75ZM66.23,25.02l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.89,17.23l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.13,20.82l-1-1,2.76-2.75,1,1-2.76,2.75ZM71.44,19.83l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,12.04l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.34,15.63l-1-1,2.76-2.75,1,1-2.76,2.75ZM76.64,14.64l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,6.85l-2.6,2.6.85.85,2.6-2.6-.85-.85Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.55,10.44l-1-1,2.76-2.75,1,1-2.76,2.75ZM81.85,9.44l.7.69,2.45-2.45-.7-.69-2.45,2.45Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64,83.17c-.08,0-.16-.03-.23-.09l-.8-.8c-.06-.06-.09-.14-.09-.23s.03-.17.09-.23L84.61,6.07c.12-.12.33-.12.45,0l.8.8c.06.06.09.14.09.23s-.03.17-.09.23L9.87,83.08c-.06.06-.14.09-.23.09ZM9.29,82.06l.34.34L85.18,7.1l-.34-.34L9.29,82.06Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.39,70.06s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21,1.36-1.36,2.11-3.16,2.11-5.08,0-1.92-.75-3.72-2.11-5.08-.74-.74-1.6-1.29-2.57-1.65l-7.06-2.28c-1.07-.37-2.02-.97-2.83-1.77-1.42-1.41-2.2-3.29-2.2-5.28s.78-3.87,2.2-5.28c2.92-2.91,7.68-2.91,10.6,0,.84.83,1.47,1.86,1.83,2.97,0,0,0,0,0,.01l.08.24s0,.02,0,.03l1.99,6.14s0,.02,0,.03c.34,1.12.96,2.16,1.8,2.99,2.81,2.8,7.38,2.8,10.19,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-2.92,2.91-7.68,2.91-10.6,0-.88-.88-1.53-1.96-1.88-3.14,0,0,0-.02,0-.03l-2.01-6.2s0,0,0-.01l-.04-.13c-.35-1.09-.96-2.09-1.77-2.9-2.81-2.8-7.38-2.8-10.19,0-1.36,1.36-2.11,3.16-2.11,5.08s.75,3.72,2.11,5.08c.77.77,1.69,1.34,2.71,1.7l7.06,2.28c1.01.38,1.91.95,2.68,1.72,1.42,1.41,2.2,3.29,2.2,5.28,0,2-.78,3.87-2.2,5.28-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.44,56.05s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21,1.36-1.36,2.11-3.16,2.11-5.08s-.75-3.72-2.11-5.08c-.74-.73-1.6-1.29-2.57-1.65l-7.06-2.28c-1.07-.37-2.02-.97-2.83-1.77-1.42-1.41-2.19-3.29-2.19-5.28,0-2,.78-3.87,2.19-5.28,2.92-2.91,7.68-2.91,10.6,0,.84.83,1.47,1.86,1.83,2.97,0,0,0,0,0,.01l.08.24s0,.02,0,.02l1.99,6.14s0,.02,0,.03c.34,1.12.96,2.16,1.8,2.99,2.81,2.8,7.38,2.8,10.19,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-2.92,2.91-7.68,2.91-10.6,0-.88-.88-1.53-1.96-1.88-3.14,0,0,0-.02,0-.03l-2.01-6.2s0,0,0-.01l-.04-.13c-.35-1.09-.96-2.09-1.77-2.9-2.81-2.8-7.38-2.8-10.19,0-1.36,1.36-2.11,3.16-2.11,5.08,0,1.92.75,3.72,2.11,5.08.78.77,1.69,1.35,2.71,1.7l7.06,2.28c1.01.38,1.91.95,2.68,1.72,1.42,1.41,2.19,3.29,2.19,5.28s-.78,3.87-2.19,5.28c-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49,42.04s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21,1.36-1.36,2.11-3.16,2.11-5.08,0-1.92-.75-3.72-2.11-5.08-.74-.73-1.6-1.29-2.57-1.65l-7.06-2.28c-1.07-.37-2.02-.97-2.83-1.77-1.42-1.41-2.2-3.29-2.2-5.28s.78-3.87,2.2-5.28c.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.36,1.36-2.11,3.16-2.11,5.08s.75,3.72,2.11,5.08c.77.77,1.69,1.35,2.71,1.7l7.06,2.28c1.01.38,1.91.95,2.68,1.72,1.42,1.41,2.2,3.29,2.2,5.28,0,2-.78,3.87-2.2,5.28-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.61,110.91s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.93-.93,1.44-2.16,1.44-3.47,0-1.31-.51-2.54-1.44-3.46-.5-.5-1.09-.88-1.75-1.13l-4.86-1.57c-.75-.26-1.41-.68-1.97-1.23-.98-.98-1.53-2.29-1.53-3.67,0-1.39.54-2.69,1.53-3.67,2.03-2.02,5.34-2.02,7.37,0,.58.58,1.02,1.29,1.27,2.07,0,0,0,0,0,0l.05.16s0,.01,0,.02l1.37,4.23s0,.01,0,.02c.23.77.66,1.47,1.23,2.04,1.92,1.91,5.04,1.91,6.95,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-2.03,2.02-5.33,2.02-7.37,0-.61-.61-1.06-1.36-1.31-2.18,0,0,0,0,0-.01l-1.39-4.28s0,0,0-.01l-.03-.08c-.24-.74-.65-1.42-1.21-1.98-1.92-1.91-5.04-1.91-6.95,0-.93.93-1.44,2.16-1.44,3.46s.51,2.54,1.44,3.47c.53.53,1.15.92,1.85,1.16l4.86,1.57c.71.26,1.33.66,1.86,1.19.98.98,1.53,2.28,1.53,3.67,0,1.39-.54,2.69-1.53,3.67-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.88,101.66s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.93-.93,1.44-2.16,1.44-3.47,0-1.31-.51-2.54-1.44-3.46-.5-.5-1.09-.88-1.75-1.13l-4.86-1.57c-.75-.26-1.41-.68-1.97-1.23-.98-.98-1.53-2.29-1.53-3.67,0-1.39.54-2.69,1.53-3.67,2.03-2.02,5.34-2.02,7.37,0,.58.58,1.02,1.29,1.27,2.07,0,0,0,0,0,0l.05.17s0,.01,0,.02l1.37,4.23s0,.01,0,.02c.23.77.66,1.47,1.23,2.04,1.92,1.91,5.04,1.91,6.95,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-2.03,2.02-5.33,2.02-7.37,0-.61-.61-1.06-1.36-1.31-2.18,0,0,0,0,0-.01l-1.39-4.28s0,0,0-.01l-.03-.08c-.24-.74-.65-1.42-1.21-1.98-1.92-1.91-5.04-1.91-6.95,0-.93.93-1.44,2.16-1.44,3.46,0,1.31.51,2.54,1.44,3.47.53.53,1.15.92,1.85,1.16l4.86,1.57c.71.26,1.33.66,1.86,1.19.98.98,1.53,2.28,1.53,3.67,0,1.39-.54,2.69-1.53,3.67-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,92.02s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.93-.93,1.44-2.16,1.44-3.47,0-1.31-.51-2.54-1.44-3.46-.5-.5-1.09-.88-1.75-1.13l-4.86-1.57c-.75-.26-1.41-.67-1.97-1.23-.98-.98-1.53-2.29-1.53-3.67,0-1.39.54-2.69,1.53-3.67,2.03-2.02,5.34-2.02,7.37,0,.58.58,1.02,1.29,1.27,2.07,0,0,0,0,0,.01l.05.17s0,.01,0,.02l1.37,4.23s0,.01,0,.02c.23.77.66,1.47,1.23,2.04,1.92,1.91,5.04,1.91,6.95,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-2.03,2.02-5.33,2.02-7.37,0-.61-.61-1.06-1.36-1.31-2.18,0,0,0,0,0-.01l-1.39-4.28s0,0,0-.01l-.02-.07c-.23-.75-.65-1.43-1.21-1.99-1.92-1.91-5.04-1.91-6.95,0-.93.93-1.44,2.16-1.44,3.46,0,1.31.51,2.54,1.44,3.47.53.53,1.15.92,1.85,1.16l4.86,1.57c.71.26,1.33.66,1.86,1.19.98.98,1.53,2.28,1.53,3.67,0,1.39-.54,2.69-1.53,3.67-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.42,83.18s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.93-.93,1.44-2.16,1.44-3.47,0-1.31-.51-2.54-1.44-3.46-.5-.5-1.09-.88-1.75-1.13l-4.86-1.57c-.75-.26-1.41-.68-1.97-1.23-.98-.98-1.53-2.29-1.53-3.67,0-1.39.54-2.69,1.53-3.67,2.03-2.02,5.34-2.02,7.37,0,.58.58,1.02,1.3,1.27,2.07,0,0,0,0,0,0l.05.17s0,.01,0,.02l1.37,4.23s0,.01,0,.02c.23.77.66,1.47,1.23,2.04,1.92,1.91,5.04,1.91,6.95,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-2.03,2.02-5.33,2.02-7.37,0-.61-.61-1.06-1.36-1.31-2.18,0,0,0-.01,0-.02l-1.39-4.28s0,0,0-.01l-.03-.1c-.24-.73-.65-1.41-1.2-1.96-1.92-1.91-5.04-1.91-6.95,0-.93.93-1.44,2.16-1.44,3.46,0,1.31.51,2.54,1.44,3.47.53.53,1.15.92,1.85,1.16l4.86,1.57c.71.26,1.33.66,1.86,1.19.98.98,1.53,2.28,1.53,3.67,0,1.39-.54,2.69-1.53,3.67-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.98,97.6s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.41-.41.63-.95.63-1.53,0-.58-.23-1.12-.63-1.53-.22-.22-.48-.39-.77-.5l-2.22-.72c-.35-.12-.67-.32-.93-.58-.46-.46-.72-1.08-.72-1.73,0-.65.26-1.27.72-1.73.96-.95,2.52-.95,3.48,0,.28.28.49.62.6.99l.02.06s0,.01,0,.02l.62,1.92c.1.34.29.66.54.91.84.84,2.22.84,3.06,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-.96.96-2.52.96-3.48,0-.29-.29-.5-.64-.62-1.03l-.64-1.96s0,0,0,0l-.02-.05s0,0,0,0c-.1-.32-.29-.62-.53-.86-.84-.84-2.22-.84-3.06,0-.41.41-.63.95-.63,1.53,0,.58.23,1.12.63,1.53.23.23.51.4.82.51l2.22.72c.34.13.63.31.88.56.46.46.72,1.08.72,1.73,0,.65-.26,1.27-.72,1.73-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,93.19s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.41-.41.63-.95.63-1.53,0-.58-.23-1.12-.63-1.53-.22-.22-.48-.39-.77-.5l-2.22-.72c-.35-.12-.67-.32-.93-.58-.46-.46-.72-1.08-.72-1.73,0-.65.26-1.27.72-1.73.96-.96,2.52-.96,3.48,0,.28.28.49.62.6.99l.02.06s0,.01,0,.02l.62,1.92c.1.34.29.66.54.91.84.84,2.22.84,3.06,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-.96.96-2.52.96-3.48,0-.29-.29-.5-.64-.62-1.03l-.64-1.96h0s-.02-.06-.02-.06c0,0,0,0,0,0-.1-.32-.29-.62-.53-.86-.84-.84-2.22-.84-3.06,0-.41.41-.63.95-.63,1.53,0,.58.23,1.12.63,1.53.23.23.51.4.82.51l2.22.72c.34.13.63.32.88.57.46.46.72,1.08.72,1.73,0,.65-.26,1.27-.72,1.73-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.82,88.79s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.41-.41.63-.95.63-1.53,0-.58-.23-1.12-.63-1.53-.22-.22-.48-.39-.77-.5l-2.22-.72c-.35-.12-.66-.32-.93-.58-.46-.46-.72-1.08-.72-1.73,0-.65.26-1.27.72-1.73.96-.96,2.52-.96,3.48,0,.28.28.49.62.6.99l.02.06s0,.01,0,.02l.62,1.92c.1.34.29.66.54.91.84.84,2.22.84,3.06,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-.96.96-2.52.96-3.48,0-.29-.29-.5-.64-.62-1.03l-.64-1.96h0s-.02-.06-.02-.06c0,0,0,0,0,0-.1-.32-.29-.62-.53-.86-.84-.84-2.22-.84-3.06,0-.41.41-.63.95-.63,1.53,0,.58.23,1.12.63,1.53.23.23.51.4.82.51l2.22.72c.34.13.63.32.88.57.46.46.72,1.08.72,1.73,0,.65-.26,1.27-.72,1.73-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.24,84.38s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.41-.41.63-.95.63-1.53,0-.58-.23-1.12-.63-1.53-.22-.22-.48-.39-.77-.5l-2.22-.72c-.35-.12-.66-.32-.93-.58-.46-.46-.72-1.08-.72-1.73s.26-1.27.72-1.73c.96-.96,2.52-.96,3.48,0,.28.28.49.62.6.99l.02.07s0,.01,0,.02l.62,1.92c.1.34.29.66.54.91.84.84,2.22.84,3.06,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-.96.96-2.52.96-3.48,0-.29-.29-.5-.64-.62-1.03l-.64-1.96s0,0,0,0l-.02-.05s0,0,0,0c-.1-.32-.29-.62-.53-.86-.84-.84-2.22-.84-3.06,0-.41.41-.63.95-.63,1.53s.23,1.12.63,1.53c.23.23.51.4.82.51l2.22.72c.34.13.63.32.88.57.46.46.72,1.08.72,1.73,0,.65-.26,1.27-.72,1.73-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.66,79.97s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.41-.41.63-.95.63-1.53s-.23-1.12-.63-1.53c-.22-.22-.48-.39-.77-.5l-2.22-.72c-.35-.12-.66-.32-.93-.58-.46-.46-.72-1.08-.72-1.73s.26-1.27.72-1.73c.96-.96,2.52-.96,3.48,0,.28.28.49.62.61,1l.02.06s0,.01,0,.02l.62,1.92c.1.34.29.66.54.91.84.84,2.22.84,3.06,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-.96.96-2.52.96-3.48,0-.29-.29-.5-.64-.62-1.03l-.64-1.96s0,0,0,0h0s-.02-.05-.02-.05c0,0,0,0,0,0-.1-.32-.29-.61-.53-.85-.84-.84-2.22-.84-3.06,0-.41.41-.63.95-.63,1.53s.23,1.12.63,1.53c.23.23.51.4.82.51l2.22.72c.34.13.63.32.88.57.46.46.72,1.08.72,1.73,0,.65-.26,1.27-.72,1.73-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.08,75.57s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.41-.41.63-.95.63-1.53s-.23-1.12-.63-1.53c-.22-.22-.48-.39-.77-.5l-2.22-.72c-.35-.12-.67-.32-.93-.58-.46-.46-.72-1.08-.72-1.73,0-.65.26-1.27.72-1.73.96-.96,2.52-.96,3.48,0,.28.28.49.62.61,1l.02.05s0,.01,0,.02l.62,1.92c.1.34.29.66.54.91.84.84,2.22.84,3.06,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-.96.95-2.52.95-3.48,0-.29-.29-.5-.64-.62-1.03l-.64-1.96s0,0,0,0c0,0,0,0,0,0l-.02-.05s0,0,0,0c-.1-.32-.29-.61-.53-.85-.84-.84-2.22-.84-3.06,0-.41.41-.63.95-.63,1.53,0,.58.23,1.12.63,1.53.23.23.51.4.82.51l2.22.72c.34.13.63.32.88.57.46.46.72,1.08.72,1.73s-.26,1.27-.72,1.73c-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,71.16s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.41-.41.63-.95.63-1.53s-.23-1.12-.63-1.53c-.22-.22-.48-.39-.77-.5l-2.22-.72c-.35-.12-.66-.32-.93-.58-.46-.46-.72-1.08-.72-1.73,0-.65.26-1.27.72-1.73.96-.96,2.52-.95,3.48,0,.28.28.49.63.61,1l.02.05s0,.01,0,.02l.62,1.92c.1.34.29.66.55.91.84.84,2.22.84,3.06,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-.96.96-2.52.96-3.48,0-.29-.29-.5-.64-.62-1.03l-.64-1.96s0,0,0,0c0,0,0,0,0,0l-.02-.05s0,0,0,0c-.1-.32-.29-.61-.53-.85-.84-.84-2.22-.84-3.06,0-.41.41-.63.95-.63,1.53,0,.58.23,1.12.63,1.53.23.23.51.4.82.51l2.22.72c.34.13.63.32.88.57.46.46.72,1.08.72,1.73s-.26,1.27-.72,1.73c-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.92,66.75s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.41-.41.63-.95.63-1.53,0-.58-.23-1.12-.63-1.53-.22-.22-.48-.39-.77-.5l-2.22-.72c-.35-.12-.67-.32-.93-.58-.46-.46-.72-1.08-.72-1.73,0-.65.26-1.27.72-1.73.96-.96,2.52-.96,3.48,0,.28.28.49.63.61,1l.02.05s0,.01,0,.02l.62,1.92c.1.34.29.66.54.91.84.84,2.22.84,3.06,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-.96.95-2.52.96-3.48,0-.29-.29-.5-.64-.62-1.03l-.64-1.96s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0l-.02-.05h0c-.1-.33-.29-.62-.53-.86-.84-.84-2.22-.84-3.06,0-.41.41-.63.95-.63,1.53,0,.58.23,1.12.63,1.53.23.23.51.4.82.51l2.22.72c.34.13.63.32.88.57.46.46.72,1.08.72,1.73,0,.65-.26,1.27-.72,1.73-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.21,90.57s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.87-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.58.74.73,1.18,0,0,0,0,0,0l.03.09s0,0,0,0l.77,2.37c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.05c-.13-.41-.36-.78-.66-1.09-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.64,85.16s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.88-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.34.33.59.75.73,1.19l.03.09s0,0,0,0l.77,2.37c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06s0,0,0,0c-.13-.4-.36-.77-.66-1.07-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.07,79.75s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.87-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.34.34.59.75.73,1.2l.03.08s0,0,0,0l.77,2.37c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06s0,0,0,0c-.13-.4-.36-.77-.66-1.07-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5,74.34s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.88-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.58.74.73,1.18,0,0,0,0,0,0l.03.09s0,0,0,0l.77,2.38c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.05c-.13-.41-.36-.78-.66-1.09-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.01.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.93,68.92s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.88-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.34.33.59.75.73,1.2l.03.08s0,0,0,0l.77,2.38c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06s0,0,0,0c-.13-.4-.36-.77-.66-1.07-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,63.51s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.88-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.58.74.73,1.18,0,0,0,0,0,0l.03.09s0,0,0,.01l.77,2.37c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06c-.13-.4-.36-.78-.66-1.08-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.78,58.1s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.87-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.34.34.59.76.74,1.21l.02.07s0,0,0,0l.77,2.37c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06s0,0,0,0c-.13-.4-.36-.77-.66-1.06-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.21,52.69s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.87-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.58.74.73,1.18,0,0,0,0,0,0l.02.06s0,0,0,0v.03s.01,0,.01,0l.77,2.38c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06c-.13-.4-.36-.78-.66-1.08-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.01.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.64,47.28s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.87-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.34.34.59.76.74,1.21v.03s.01,0,.01,0v.03s0,0,.01,0l.77,2.38c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06s0,0,0,0c-.13-.4-.36-.77-.66-1.06-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.72.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.07,41.86s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.88-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.58.74.73,1.18,0,0,0,0,0,0l.03.09s0,0,0,.01l.77,2.37c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.05c-.13-.41-.36-.78-.66-1.08-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,36.45s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.87-1.31-.87-2.11,0-.79.31-1.54.87-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.58.74.73,1.18,0,0,0,0,0,0l.03.09s0,0,0,.01l.77,2.37c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06c-.13-.4-.36-.78-.66-1.08-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.02.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.93,31.04s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.88-1.31-.87-2.11,0-.79.31-1.54.88-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.58.74.73,1.18,0,0,0,0,0,0l.03.09s0,0,0,.01l.77,2.37c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06c-.13-.4-.36-.78-.66-1.08-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.01.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.36,25.63s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.88-1.31-.88-2.11,0-.79.31-1.54.88-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.59.74.73,1.19,0,0,0,0,0,0l.02.06s0,0,0,0v.03s0,0,.01,0l.77,2.38c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06c-.13-.4-.36-.77-.66-1.07-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.01.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,20.22s-.07-.01-.1-.04c-.06-.06-.06-.15,0-.21.51-.51.79-1.18.79-1.9,0-.72-.28-1.39-.79-1.9-.28-.28-.6-.48-.96-.62l-2.72-.88c-.43-.15-.81-.39-1.13-.71-.56-.56-.88-1.31-.87-2.11,0-.79.31-1.54.88-2.1,1.16-1.16,3.06-1.16,4.22,0,.33.33.59.74.73,1.19l.02.05s0,0,0,0v.03s0,0,.01,0l.77,2.38c.13.43.36.82.68,1.13,1.05,1.05,2.76,1.05,3.81,0,.06-.06.15-.06.21,0,.06.06.06.15,0,.21-1.16,1.16-3.06,1.16-4.22,0-.35-.35-.61-.78-.75-1.25l-.78-2.39s0-.01,0-.02l-.02-.06s0,0,0,0c-.13-.4-.36-.77-.66-1.07-1.05-1.05-2.76-1.05-3.81,0-.51.51-.79,1.18-.79,1.9,0,.72.28,1.39.79,1.9.29.29.63.5,1.01.64l2.73.88c.41.15.76.38,1.07.69.56.56.87,1.31.87,2.1,0,.8-.31,1.54-.87,2.11-.03.03-.07.04-.1.04Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.71,75.71c-.08,0-.16-.03-.23-.09l-19.37-19.31c-.13-.12-.13-.33,0-.45.12-.13.33-.13.45,0l19.37,19.31c.13.12.13.33,0,.45-.06.06-.14.09-.23.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04,79.27c-.08,0-.16-.03-.23-.09-.12-.13-.12-.33,0-.45L80.97,2.98c.13-.12.33-.12.45,0,.12.13.12.33,0,.45L5.27,79.18c-.06.06-.14.09-.23.09Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1,16.86s-.03,0-.04,0c-.08-.01-.16-.06-.21-.12l-1.53-2c-.11-.14-.08-.34.06-.45L77.85.07c.07-.05.15-.08.24-.06.08.01.16.05.21.12l2.6,3.38c.1.13.09.31-.03.42l-1.71,1.7c-.06.06-.15.1-.25.09-.09,0-.18-.05-.23-.12l-1.07-1.38-16.32,12.57c-.06.04-.12.07-.2.07ZM60.02,14.6l1.14,1.49,16.32-12.57c.14-.11.34-.08.45.06l1.04,1.34,1.25-1.25-2.24-2.91-17.97,13.83Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.05,7.6s-.01,0-.02,0c-.09,0-.18-.05-.23-.12l-1.47-1.89c-.05-.07-.08-.15-.06-.24s.05-.16.12-.21l2.09-1.61c.14-.11.34-.08.45.06l1.26,1.63c.1.13.09.31-.03.42l-1.88,1.87c-.06.06-.14.09-.23.09ZM76.04,5.44l1.05,1.35,1.42-1.42-.89-1.15-1.58,1.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.29,31.59s-.03,0-.04,0c-.08-.01-.16-.06-.21-.12l-1.53-2c-.11-.14-.08-.34.06-.45l18.47-14.22c.07-.05.15-.08.24-.06.08.01.16.05.21.12l2.6,3.38c.1.13.09.31-.03.42l-1.71,1.7c-.06.06-.15.1-.25.09-.09,0-.18-.05-.23-.12l-1.07-1.38-16.32,12.57c-.06.04-.12.07-.2.07ZM45.2,29.34l1.14,1.49,16.32-12.57c.14-.11.34-.08.45.06l1.04,1.34,1.25-1.25-2.24-2.91-17.97,13.83Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.24,22.33s-.01,0-.02,0c-.09,0-.18-.05-.23-.12l-1.47-1.89c-.05-.07-.08-.15-.06-.24.01-.08.05-.16.12-.21l2.09-1.61c.14-.11.34-.08.45.06l1.26,1.63c.1.13.09.31-.03.42l-1.88,1.87c-.06.06-.14.09-.23.09ZM61.22,20.18l1.05,1.35,1.43-1.42-.89-1.15-1.58,1.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.47,46.33s-.03,0-.04,0c-.08-.01-.16-.06-.21-.12l-1.53-2c-.11-.14-.08-.34.06-.45l18.47-14.22c.07-.05.15-.08.24-.06.08.01.16.05.21.12l2.6,3.38c.1.13.09.31-.03.42l-1.71,1.7c-.06.06-.15.1-.25.09-.09,0-.18-.05-.23-.12l-1.07-1.38-16.32,12.57c-.06.04-.12.07-.2.07ZM30.39,44.07l1.14,1.49,16.32-12.57c.14-.11.34-.08.45.06l1.04,1.34,1.25-1.25-2.24-2.91-17.97,13.83Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.43,37.06s-.01,0-.02,0c-.09,0-.18-.05-.23-.12l-1.47-1.89c-.05-.07-.08-.15-.06-.24s.05-.16.12-.21l2.09-1.61c.14-.11.34-.08.45.06l1.26,1.63c.1.13.09.31-.03.42l-1.88,1.87c-.06.06-.14.09-.23.09ZM46.41,34.91l1.05,1.35,1.42-1.42-.89-1.15-1.58,1.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.66,61.06s-.03,0-.04,0c-.08-.01-.16-.06-.21-.12l-1.53-2c-.11-.14-.08-.34.06-.45l18.47-14.22c.07-.05.15-.08.24-.06.08.01.16.05.21.12l2.6,3.38c.1.13.09.31-.03.42l-1.71,1.7c-.06.06-.15.1-.25.09-.09,0-.18-.05-.23-.12l-1.07-1.37-16.32,12.57c-.06.04-.12.07-.2.07ZM15.58,58.8l1.14,1.49,16.32-12.57c.14-.11.34-.08.45.06l1.04,1.34,1.25-1.25-2.24-2.91-17.97,13.83Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.62,51.8s-.01,0-.02,0c-.09,0-.18-.05-.23-.12l-1.47-1.89c-.05-.07-.08-.15-.06-.24.01-.08.05-.16.12-.21l2.09-1.61c.14-.11.34-.08.45.06l1.26,1.63c.1.13.09.31-.03.42l-1.88,1.87c-.06.06-.14.09-.23.09ZM31.6,49.64l1.05,1.35,1.42-1.42-.89-1.15-1.58,1.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85,75.79s-.03,0-.04,0c-.08-.01-.16-.06-.21-.12l-1.53-2c-.11-.14-.08-.34.06-.45l18.47-14.22c.07-.05.15-.08.24-.06.08.01.16.05.21.12l2.6,3.38c.1.13.09.31-.03.42l-1.71,1.7c-.07.06-.15.1-.25.09-.09,0-.18-.05-.23-.12l-1.07-1.37-16.32,12.57c-.06.04-.12.07-.2.07ZM.77,73.54l1.14,1.49,16.32-12.57c.14-.11.34-.08.45.06l1.04,1.34,1.25-1.25-2.24-2.91L.77,73.54Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8,66.53s-.01,0-.02,0c-.09,0-.18-.05-.23-.12l-1.47-1.89c-.05-.07-.08-.15-.06-.24s.05-.16.12-.21l2.09-1.61c.14-.11.34-.08.45.06l1.26,1.63c.1.13.09.31-.03.42l-1.88,1.87c-.06.06-.14.09-.23.09ZM16.79,64.38l1.05,1.35,1.42-1.42-.89-1.15-1.58,1.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.04.32l2.6,3.38-1.71,1.7-1.26-1.63-16.57,12.76-1.53-2L78.04.32Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.93,5.4l-1.88,1.87-1.47-1.89,2.09-1.61,1.26,1.63Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.23,15.05l2.6,3.38-1.71,1.7-1.26-1.63-16.57,12.76-1.53-2,18.47-14.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.12,20.14l-1.88,1.87-1.47-1.89,2.09-1.61,1.26,1.63Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.42,29.79l2.6,3.38-1.71,1.7-1.26-1.63-16.57,12.76-1.53-2,18.47-14.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.31,34.87l-1.88,1.87-1.47-1.89,2.09-1.61,1.26,1.63Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6,44.52l2.6,3.38-1.71,1.7-1.26-1.63-16.57,12.76-1.53-2,18.47-14.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,49.61l-1.88,1.87-1.47-1.89,2.09-1.61,1.26,1.63Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.79,59.26l2.6,3.38-1.71,1.7-1.26-1.63L1.85,75.47l-1.53-2,18.47-14.22Z",
    fill: "#234c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.69,64.34l-1.88,1.87-1.47-1.89,2.09-1.61,1.26,1.63Z",
    fill: "#234c6f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.59,22.68c-.08,0-.16-.03-.23-.09-.12-.13-.12-.33,0-.45,1.18-1.17,2.04-1.49,2.87-1.81.8-.31,1.56-.6,2.64-1.67,1.08-1.07,1.38-1.83,1.69-2.62.32-.83.66-1.68,1.84-2.85,1.18-1.17,2.04-1.49,2.87-1.81.8-.31,1.56-.6,2.65-1.67,1.08-1.07,1.38-1.83,1.69-2.62.32-.83.66-1.68,1.84-2.85.13-.12.33-.12.45,0,.12.13.12.33,0,.45-1.08,1.07-1.38,1.83-1.69,2.62-.32.83-.66,1.68-1.84,2.85-1.18,1.17-2.04,1.49-2.87,1.81-.8.31-1.56.6-2.65,1.67-1.08,1.07-1.38,1.83-1.69,2.62-.32.83-.66,1.68-1.84,2.85-1.18,1.17-2.04,1.49-2.87,1.81-.8.31-1.56.6-2.64,1.67-.06.06-.14.09-.22.09Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.76,5.61h0c-.18,0-.32-.14-.32-.32v-.68s-.68,0-.68,0c-.18,0-.32-.14-.32-.32,0-.18.14-.32.32-.32h1c.08,0,.17.04.23.1.06.06.09.14.09.23v1c0,.18-.15.32-.32.32Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84,79.11c-.08,0-.16-.03-.23-.09-.12-.13-.12-.33,0-.45,1.18-1.17,2.04-1.49,2.87-1.81.8-.31,1.56-.6,2.64-1.67,1.08-1.07,1.38-1.83,1.69-2.62.32-.83.66-1.68,1.84-2.85,1.18-1.17,2.04-1.49,2.87-1.81.8-.31,1.56-.6,2.65-1.67,1.08-1.07,1.38-1.83,1.69-2.62.32-.83.66-1.68,1.84-2.85.13-.12.33-.12.45,0,.12.13.12.33,0,.45-1.08,1.07-1.38,1.83-1.69,2.62-.32.83-.66,1.68-1.84,2.85-1.18,1.17-2.04,1.49-2.87,1.81-.8.31-1.56.6-2.64,1.67-1.08,1.07-1.38,1.83-1.69,2.62-.32.83-.66,1.68-1.84,2.85-1.18,1.17-2.04,1.49-2.87,1.81-.8.31-1.56.6-2.64,1.67-.06.06-.14.09-.22.09Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.02,62.04h0c-.18,0-.32-.14-.32-.32v-.68s-.68,0-.68,0c-.18,0-.32-.14-.32-.32,0-.18.14-.32.32-.32h1c.08,0,.17.04.23.1.06.06.09.14.09.23v1c0,.18-.15.32-.32.32Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.58,35.57h0c-.18,0-.32-.14-.32-.32v-.68s-.68,0-.68,0c-.18,0-.32-.14-.32-.32,0-.18.14-.32.32-.32h1c.08,0,.17.04.23.1.06.06.09.14.09.23v1c0,.18-.15.32-.32.32Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.26,52.72c-.08,0-.16-.03-.23-.09-.12-.13-.12-.33,0-.45,1.08-1.07,1.38-1.83,1.69-2.62.32-.83.66-1.68,1.84-2.85,1.18-1.17,2.04-1.49,2.87-1.81.8-.31,1.56-.6,2.64-1.67,1.08-1.07,1.38-1.83,1.69-2.62.32-.83.66-1.68,1.84-2.85,1.18-1.17,2.04-1.49,2.87-1.81.8-.31,1.56-.6,2.64-1.67.13-.12.33-.12.45,0,.12.13.12.33,0,.45-1.18,1.17-2.04,1.49-2.87,1.81-.8.31-1.56.6-2.64,1.67-1.08,1.07-1.38,1.83-1.69,2.62-.32.83-.66,1.68-1.84,2.85-1.18,1.17-2.04,1.49-2.87,1.81-.8.31-1.56.6-2.64,1.67-1.08,1.07-1.38,1.83-1.69,2.62-.32.83-.66,1.68-1.84,2.85-.06.06-.14.09-.23.09Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.07,72.59l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.96,62.7l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.85,52.81l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.74,42.92l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.63,33.03l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.52,23.14l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.41,13.25l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.32,80.84l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.21,70.95l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,61.06l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.99,51.17l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.88,41.28l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.77,31.39l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.66,21.5l-4.83,4.83,1.35,1.36,4.83-4.83-1.35-1.36Z",
    fill: "#0090d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchedRoofMajcoat);
export default __webpack_public_path__ + "static/media/pitched_roof_majcoat.e360ec061ead7e7086eb75e845edc130.svg";
export { ForwardRef as ReactComponent };